<template>
  <div class="login-page container">
      <div class="logo">
        <div class="logo--text">
          <logo logoType="login"/>
        </div>
      </div>
      <div class="login-form">
      <h2 v-if="source == 'logout'">{{$t('ui.pages.logout')}}</h2>
      <h2 v-else>{{$t('ui.pages.login')}}</h2>
      <p v-if="source == 'logout'" class="subtitle">{{$t('ui.pages.logout_details')}}</p>
      <p v-else class="subtitle">{{$t('ui.pages.login_details')}}</p>
      <form @submit.prevent="login" class="login-form">
        <field name="email" type="email" placeholder="me@example.com" label="ui.auth.email" v-model="email"></field>
        <field name="password" autocomplete="current-password" type="password" :placeholder="placeholder" label="ui.auth.password" v-model="password"></field>
        <div class="submit">
          <button type="submit" class='btn btn-primary btn-login' data-action="user.login">{{ $t('ui.auth.button') }}</button>
        </div>
        <form-switch model="auth" name="remember_me" v-model="remember_me"></form-switch>
      </form>
      <div class="actions">
        <router-link class="forgot-password" :to="{name:'password_reset_request'}">{{$t('ui.auth.password_reset')}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from '@/components/layouts/partials/Logo'
import Field from '@/components/helpers/DataInput/Field'
import PasswordResetRequest from '@/components/auth/PasswordResetRequest'
import Auth from '@/api/Auth'
import Session from '@/classes/Session'
import Api from '@/api/Api'
import FormSwitch from '@/components/helpers/DataInput/FormSwitch'

export default {
  components: {
    Field,
    PasswordResetRequest,
    FormSwitch,
    Logo
  },
  metaInfo: {
      title: 'Login',
  },
  data(){
    return {
      email: '',
      password: '',
      remember_me: false,
      error: '',
      source: 'classic',
      icon: '\u2022'
    }
  },
  computed: {
   placeholder: function () {
     return this.icon.repeat(8)
   }
 },
  mounted(){
    if(this.$route.query){
      this.source = this.$route.query.source
    }
    if (this.source === 'logout') {
      this.$store.commit('SET_NOTIFICATION', {
        'title': this.$t('errors.authentication.logout'),
        'type': 'success'
      })
      Session.logout()
      this.$emit('logout')
    }
  },
  methods: {
    passwordReset(){
      this.mode = "request_password_reset"
    },
    async login(){
      let auth = new Auth()

      auth.auth(this.email, this.password).then(async (response) => {
        let user = null
        if(this.remember_me){
          user = Session.login(response.data.jwt_token, 7)
        }else{
          user = Session.login(response.data.jwt_token)
        }

        this.$emit('login')
        this.$router.push({ name: 'home' })
      }).catch(e => {
        console.log(e)
        this.error = e.response.data.errors[0]
      })
    }
  }
}
</script>
<style lang="scss">
.login-page{
  padding-top: 4em;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  .login-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .forgot-password {
    color: $sensual;
    font-weight: $font-medium;
    font-size: 14px;
    transition: all .15s ease-out;
    &:hover {
      color: $sensual-dark;
    }
    &:active {
      color: $sensual-darker;
    }
  }
  .form-switch{
    // display: block;
    margin: 15px auto;
    justify-content: center;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    label {
      align-self: flex-end;
      padding-right: 1em;
    }
    &.value-true{
      .switch-container{
        background-color: $sensual;
      }
      .switch-button{
        background-color: $paper-light;
      }
    }
    &.value-false {
      .switch-container{
        background-color: $paper;
      }
    }
    label {
      color: $ink;
      font-weight: 400;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Login.vue?ece7e886